import { Boton, Dialogo } from "@/components/ui";
import { MOTIVOS } from "@/lib/motivos";

/** "¿Qué estuvo mal?" — lo comparten el chat y los reportes. */
export function DialogoMotivo({ abierto, onCerrar, onElegir }: { abierto: boolean; onCerrar: () => void; onElegir: (motivo: string) => void }) {
  return (
    <Dialogo abierto={abierto} onCerrar={onCerrar} titulo="¿Qué estuvo mal?">
      <div className="flex flex-col gap-2 p-5">
        {MOTIVOS.map((mo) => <button key={mo} type="button" className="rounded-md border border-borde px-3 py-2 text-left text-sm hover:border-primary" onClick={() => onElegir(mo)}>{mo}</button>)}
        <Boton variante="fantasma" className="mt-1" onClick={onCerrar}>Cancelar</Boton>
      </div>
    </Dialogo>
  );
}
